// angular
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-tender-card-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, NgClass],
  templateUrl: './tender-card-skeleton.component.html',
  styleUrl: './tender-card-skeleton.component.scss',
  host: {
    '[class.tender-card-skeleton-host--list]': 'wrapInListItem()',
  },
})
export class TenderCardSkeletonComponent {
  count = input<number>(1);
  wrapInListItem = input<boolean>(false);
  containerClasses = input<string>('');

  public counter(i: number) {
    return new Array(i);
  }
}
